import * as React from "react";
const BillingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 2.39v20M17 5.39H9.5a3 3 0 0 0 0 6h5a3 3 0 0 1 0 6H7"
    />
  </svg>
);
export default BillingIcon;
